import * as firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/firestore';
import 'firebase/storage';

const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ''
};

export default class Firebase {
    private static _instance: Firebase;

    public readonly app: firebase.app.App;
    public readonly store: firebase.firestore.Firestore;
    public readonly storage: firebase.storage.Storage;
    public readonly auth: firebase.auth.Auth;
    public readonly providerGoogle = new firebase.auth.GoogleAuthProvider();

    private constructor() {
        this.app = firebase.initializeApp(config);
        this.store = this.app.firestore();
        this.auth = this.app.auth();
        this.storage = this.app.storage()
    }

    public static get instance(): Firebase {
        if (!this._instance) {
            this._instance = new Firebase();
        }
        return this._instance;
    }
}
